export const DeviceFragment = /* GraphQL */ `
	fragment DeviceFragment on Device {
		_id
		created_at
		updated_at
		fcm_tokens
		_active_orders {
			_id
			created_at
			updated_at
			index
			prepared_at
			processed_at
			paid_at
			cancelled_at
			customer
			venue
			status
			is_paid
			staff
			original_orders
			cancelled_reason
			source
			device
			prep_time
			currencies_configs
			location
			current_location
			max_prepare_time
			items_count
			items_count_by_types
			prepped_count
			subtotal
			offer_amount
			discount_amount
			net_amount
			vat_amount
			service_charge_amount
			service_charge_bd_amount
			adjustment_amount
			grand_total
			gross_amount
			cancelled_amount
			receipt
			is_needing_prep_time_confirmation
			is_needing_prep_time_acknowledgement
			note
			is_cancelled
			is_bill_printed
			is_needing_payment_confirmation
			is_request_payment_confirmation
			_location {
				_id
				name
			}
		}
	}
`;
